module.exports = __webpack_public_path__ + "media/src/images/not-image-8fab9b489e0f298760e3488e93159873.png";